import React from "react";
import DirectionType from "./DirectionType";

const Direction = (props) => (
    <div>
        <DirectionType direction={props.direction}/>
        <div style={{fontSize: "80%"}}>{props.derivativeDescription}</div>
    </div>
);
Direction.propTypes = {
    direction: React.PropTypes.string.isRequired,
    derivativeDescription: React.PropTypes.string
};

export default Direction;


/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/components/Direction.js
 **/